exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ProductBanner-module__container--3mKgT {\r\n  width: 100%;\r\n}\r\n\r\n.ProductBanner-module__codeContainer--jxKN9 {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.ProductBanner-module__codeTag--1zIpu {\r\n  margin: 27px 26px;\r\n  padding: 0 25px;\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  height: 40px;\r\n  border-radius: 20px;\r\n  background-color: #000000;\r\n  color: #ffffff;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 16px;\r\n}\r\n\r\n.ProductBanner-module__textBold--23r81 {\r\n  font-weight: bold;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "ProductBanner-module__container--3mKgT",
	"codeContainer": "ProductBanner-module__codeContainer--jxKN9",
	"codeTag": "ProductBanner-module__codeTag--1zIpu",
	"textBold": "ProductBanner-module__textBold--23r81"
};